export function extractLogs(run) {
  if (!run) return "No logs available for this run."

  if (typeof run.logs === "string") return run.logs
  if (Array.isArray(run.logs)) return run.logs.join("\n")
  if (typeof run.log === "string") return run.log

  if (run.stdout || run.stderr) {
    const parts = []
    if (run.stdout) parts.push(`--- stdout ---\n${String(run.stdout)}`)
    if (run.stderr) parts.push(`--- stderr ---\n${String(run.stderr)}`)
    return parts.join("\n\n")
  }

  if (run.events) return `--- events ---\n${JSON.stringify(run.events, null, 2)}`
  if (run.debug) return `--- debug ---\n${JSON.stringify(run.debug, null, 2)}`

  return "No logs available for this run."
}

export function downloadText(name, text) {
  const blob = new Blob([text], { type: "text/plain" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = name
  a.click()
  URL.revokeObjectURL(url)
}

export function highlightSearch(text, query) {
  if (!query) return text
  try {
    const idxs = []
    const q = query.toLowerCase()
    let i = 0
    const hay = text.toLowerCase()
    while ((i = hay.indexOf(q, i)) !== -1) {
      idxs.push([i, i + q.length])
      i += q.length
    }
    if (idxs.length === 0) return text
    const out = []
    let prev = 0
    idxs.forEach(([s, e], k) => {
      if (prev < s) out.push(<span key={`t-${k}-a`}>{text.slice(prev, s)}</span>)
      out.push(
        <span
          key={`t-${k}-b`}
          className="bg-yellow-200 text-gray-900 dark:bg-yellow-600/60 dark:text-gray-100"
        >
          {text.slice(s, e)}
        </span>
      )
      prev = e
    })
    if (prev < text.length) out.push(<span key="t-end">{text.slice(prev)}</span>)
    return out
  } catch {
    return text
  }
}
